import { render } from "./InterfaceShortcut.vue?vue&type=template&id=815efb84"
import script from "./InterfaceShortcut.vue?vue&type=script&lang=js"
export * from "./InterfaceShortcut.vue?vue&type=script&lang=js"

import "./InterfaceShortcut.vue?vue&type=style&index=0&id=815efb84&lang=scss"

import exportComponent from "/tmp/5e119732-5ebd-42f7-baa8-4916aa59fc29/frontend/core/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__